import NextLink from 'next/link';
import { Icons } from '../../atoms/icons';
import { IBreadcrumpProps } from './breadcrump.interface';
import styles from './breadcrump.module.scss';

export const Breadcrump = (breadcrumps: IBreadcrumpProps) => {
	const { crumps } = breadcrumps;

	return (
		<div className={styles['breadcrumbs-content']}>
			<ul>
				{
					crumps.map(crump => (
						<li key={crump.text}>
							<NextLink href={crump.url ? crump.url : '#'} passHref>
								<a>
									{crump.isHome ? <Icons iconName='iconHome' /> : <Icons iconName='iconChevronRight' />}
									<p>{crump.text}</p>
								</a>
							</NextLink>
						</li>
					))
				}
			</ul>
		</div>
	)
}
